export const EXIT_REASON_LABELS = {
    stopLoss: 'Stop loss',
    sellAtTarget: 'Profit target',
    sellAtClose: 'Sell at close',
    sellAtLevel: 'Price level reached',
    underlyingStopLoss: 'Underlying stop loss',
    underlyingTarget: 'Underlying target',
    maximumHoldMinutes: 'Maximum hold time',
    maximumTradingHoldMinutes: 'Maximum trading hold time',
    dataError: 'Data error',
    optionExpiry: 'Option expiry',
    endOfBars: 'End of available bars',
    profitTaking: 'Profit taking',
    profitFloor: 'Profit floor',
    sellAtWeekendClose: 'Weekend close',
    sellAbovePrice: 'Price rose above limit',
    sellBelowPrice: 'Price fell below limit',
    maximumNonProfitableHoldMinutes: 'Maximum unprofitable hold time',
    closeBeforeEarnings: 'Closed before earnings',
    closeBeforeFomc: 'Closed before FOMC',
    closeAtProfitFloor: 'Profit floor',
    closeFromProfitTakingRules: 'Profit-taking rule',
    closeAtTime: 'Scheduled close time',
    optionChainMissing: 'Option chain unavailable',
    optionExpiryAutoSell: 'Automatic sale at option expiry',
    optionExpiryAutoBuy: 'Automatic buy at option expiry',
    manualSell: 'Manual close',
    indicator: 'Indicator signal',
    profitTarget: 'Profit target',
    maxHoldBars: 'Maximum holding period',
    automatedExit: 'Automated exit',
    brokerClose: 'Broker close — origin unconfirmed'
};
export const isExitReason = (value) => typeof value === 'string' && Object.hasOwn(EXIT_REASON_LABELS, value);
/** Reporting category and authored explanation have separate meanings. */
export const formatExitReason = (reason, description) => reason === 'automatedExit' && !description?.trim() ? 'Automated exit — reason unavailable' : EXIT_REASON_LABELS[reason];
export const isAutomatedExitReason = (value) => isExitReason(value) && value !== 'manualSell' && value !== 'brokerClose';
export const authoredExitDescription = (reason, description) => {
    const explicit = typeof description === 'string' ? description.trim() : '';
    const authored = typeof reason === 'string' && !isExitReason(reason) ? reason.trim() : '';
    return (explicit || authored).slice(0, 1000) || null;
};
//# sourceMappingURL=exitReasons.js.map